export default "__VITE_ASSET__R0wfF4OQ__"